import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import ViewDayIcon from '@material-ui/icons/ViewDay';
import CheckCircleOutlineOutlined from '@material-ui/icons/CheckCircleOutlineOutlined';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import axios from '../../config/axiosInstance';
import { setMessage } from '../../store/actions/general';
import { Link } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { usageLog } from '../../store/actions/globalActions';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));


export default function FormattedInputs({
  values,
  checked,
  checkbox,
  creditCards,
  planSelected,
  disabled,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [paymentApprovedModal, setPaymentApprovedModal] = useState(false);
  const [disabledLater, setDisabledLater] = useState(false);
  const [paymentApproved, setPaymentApproved] = useState({});

  const [recurringBill, setRecurringBill] = useState(false);

  const onConfirmPayment = (response) => {
    setPaymentApproved(response);
    setPaymentApprovedModal(true);
  };

  const generateBoleto = () => {
    setDisabledLater(true);
    // onChangeValue('loading', true);
    const paymentInfo = {
      idPlan: planSelected.uuidOffer,
      ticket: values.ticket.toUpperCase(),
      priceUser: checked ? planSelected.yearlyPrice : planSelected.monthlyPrice,
      isAnnual: checked ? true : false,
      isBillet: true,
      invoice: {
        businessName: values.name,
        cnpj: values.document.replace(/\D+/g, ''),
        address: values.address,
        email: values.email,
        phone: values.phone.replace(/\D+/g, ''),
        houseNumber: values.addressNumber,
        complement: values.complement,
        neighborhood: values.district,
        city: values.city,
        cityCod: values.cityCod,
        stateCod: values.state,
        postalCode: values.zipCode || values.zipCode.replace(/\D+/g, ''),
        municipalInscription: checkbox ? 'ISENTO' : values.municipalInscription.trim(),
      },
    };
    // console.log('paymentInfo', paymentInfo)

    const companyId = JSON.parse(localStorage.getItem('companies')).find(x => x.companyId).companyId;
    const userId = JSON.parse(localStorage.getItem('companies')).find(x => x.userId).userId;
    usageLog("Assinaturas/formulario/generateBoleto", companyId, userId, paymentInfo);

    axios.post('/payments/paypal/create-order/v2', paymentInfo)
      .then(({ data }) => {
        const response = {
          type: 'boleto',
          isAnnual: checked ? true : false,
          boletoPath: data.url,
          invoiceId: data.invoiceId,
          paymentId: data.paymentId,
          title: 'Aguardando Pagamento',
          content: `Seu boleto foi enviado com sucesso, para o e-mail: (${values.email}).`,
        };

        onConfirmPayment(response);
      })
      .catch((err) => {
        // onChangeValue('loading', false);
        dispatch(setMessage(err));
      });
  };

  return (
    <div className={classes.root}>
      {!disabledLater ?
        <div style={{ width: '100%' }}>
          {!creditCards ?
            <Button
              disabled={disabled || disabledLater}
              variant="contained"
              style={{
                width: '100%',
                height: '55px',
              }}
              onClick={() => generateBoleto()}
            >
              <ViewDayIcon style={{ marginRight: '0.25em' }} />
              BOLETO COM PIX
            </Button>
            :
            ''
          }
        </div>
        : !paymentApprovedModal ?
          <div style={{
            width: '100%',
            textAlign: 'center',
            backgroundColor: '#dddddd',
            padding: '3px',
            borderRadius: '8px',
          }}>
            <CircularProgress />
          </div>
          :
          <div style={{
            width: '100%',
            textAlign: 'center',
            backgroundColor: '#dddddd',
            padding: '3px',
            borderRadius: '8px',
          }}>
            <CheckCircleOutlineOutlined
              style={{
                display: 'flex',
                margin: 'auto',
                width: '44px',
                height: '44px',
                color: 'rgb(70, 160, 69)',
              }} />
          </div>
      }

      <Dialog open={paymentApprovedModal}>
        <CheckCircleOutlineOutlined
          style={{
            display: 'flex',
            margin: '20px auto 10px auto',
            width: '89px',
            height: '89px',
            color: 'rgb(70, 160, 69)',
          }} />
        <DialogTitle style={{ textAlign: 'center' }}>Boleto enviado com sucesso</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography style={{ fontSize: '14px' }}>
              O seu plano será ativado assim que compensar o Boleto/PIX.
            </Typography>
            <Typography style={{ fontSize: '14px' }}>
              Boleto em até 3 dias úteis ou PIX em até 15 minutos.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button component={Link} to='/' >Fechar</Button>
          <Button variant="contained" color="primary"
            onClick={() => {
              if (paymentApproved.type === 'boleto') {
                window.open(paymentApproved.boletoPath, '_blank');
              } else { }
            }}
          >
            Ver boleto
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}